export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_SET_LOADER_TEXT = 'UI_SET_LOADER_TEXT';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const EXAMPLE_API = 'EXAMPLE_API';
